import { render, staticRenderFns } from "./OrmBatchingListView.vue?vue&type=template&id=2124ec6e"
import script from "./OrmBatchingListView.vue?vue&type=script&lang=js"
export * from "./OrmBatchingListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2124ec6e')) {
      api.createRecord('2124ec6e', component.options)
    } else {
      api.reload('2124ec6e', component.options)
    }
    module.hot.accept("./OrmBatchingListView.vue?vue&type=template&id=2124ec6e", function () {
      api.rerender('2124ec6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingListView.vue"
export default component.exports